import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const oil_painting_filter_faq_data = [
    {
        question: "What is the Oil Painting Filter, and how does it work?",
        answer: "The Oil Painting Filter is an AI tool that transforms photos into classic hand-painted artwork. It applies realistic brush strokes, canvas textures, and color blending techniques to give your photo the timeless look of an oil painting.",
    },
    {
        question:
            "Do I need any painting or design experience to use the Oil Painting Filter?",
        answer: "No experience is required. The Oil Painting Filter handles everything automatically — simply upload your image, and the AI converts it into a beautifully detailed digital painting in seconds.",
    },
    {
        question:
            "What kinds of photos work best with the Oil Painting Filter?",
        answer: "Portraits, landscapes, and still-life images work especially well. The filter enhances depth, lighting, and texture to emulate the warmth and richness of traditional oil paintings.",
    },
    {
        question: "Are my uploaded images private and secure?",
        answer: "Yes, all photos are private and automatically deleted several hours later after processing. Patternful.ai ensures full privacy and ownership of your generated artwork.",
    },
];

const oil_painting_filter_use_cases = [
    {
        title: "Artistic Portraits",
        description:
            "Turn your selfies or professional portraits into museum-quality oil paintings. Ideal for profile pictures, wall art, or digital keepsakes that look timeless and elegant.",
        image: "/images/image-filters/oil-painting-filter-5.webp",
    },
    {
        title: "Interior Decor & Prints",
        description:
            "Use your AI-painted artwork for framed prints, canvas displays, or gifts. The Oil Painting Filter adds artistic texture and sophistication to any home or office decor.",
        image: "/images/image-filters/oil-painting-filter-6.webp",
    },
    {
        title: "Creative Storytelling & Branding",
        description:
            "Create painterly visuals for book covers, album art, or digital storytelling projects. Perfect for artists, brands, and creators looking for a premium artistic finish.",
        image: "/images/image-filters/oil-painting-filter-7.webp",
    },
];

const OilPaintingFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/oil-painting-filter-1.webp"}
                title={"Transform Photos into Elegant Oil Paintings"}
                description={
                    "Experience your photos as timeless works of art. The Oil Painting Filter recreates the depth, texture, and brush detail of real oil paint — blending colors with precision to produce smooth, painterly compositions worthy of a canvas."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/oil-painting-filter-2.webp"}
                title={"Create Classic Portraits with Realistic Brushwork"}
                description={
                    "The AI highlights facial features and lighting to give your portraits the look of traditional oil portraiture. Soft transitions, rich tones, and hand-painted effects make each result feel unique and expressive."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/oil-painting-filter-3.webp"}
                title={"Turn Landscapes and Objects into Painted Scenes"}
                description={
                    "Bring your travel, nature, or architecture photos to life with painterly texture. The Oil Painting Filter enhances light, shadow, and color depth — giving your images a serene, gallery-worthy finish."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/oil-painting-filter-4.webp"}
                title={"Perfect for Art Prints and Professional Projects"}
                description={
                    "Whether you’re printing a family portrait or designing for a creative campaign, the Oil Painting Filter offers studio-grade quality and realistic brush detail for professional or personal use."
                }
            />
            <UseCases
                data={oil_painting_filter_use_cases}
                title={"Creative and Pretty Oil Painting Filters for Everyone"}
            />
            <SellFaq data={oil_painting_filter_faq_data} />
        </PBox>
    );
};

export default OilPaintingFilter;
